import { useMutation } from "urql";

import { graphql } from "@/gen";

export const addFeedRecordMutation = graphql(`
    mutation addRecord($input: AddFeedRecordInput!) {
        addFeedRecord(input: $input) {
            id
        }
    }
`);

export const useAddPoll = () => {
    return useMutation(
        graphql(`
            mutation addPoll($input: AddPollInput!) {
                addPoll(input: $input) {
                    id
                }
            }
        `)
    );
};
export const useUpdatePoll = () => {
    return useMutation(
        graphql(`
            mutation updatePoll($input: UpdatePollInput!) {
                updatePoll(input: $input) {
                    id
                }
            }
        `)
    );
};

export const useAddAnalysis = () => {
    return useMutation(
        graphql(`
            mutation addAnalysis($input: AddAnalysisInput!) {
                addAnalysis(input: $input) {
                    id
                }
            }
        `)
    );
};

export const updateFeedRecordMutation = graphql(`
    mutation updateFeedRecord($input: UpdateFeedRecordInput!) {
        updateFeedRecord(input: $input) {
            id
        }
    }
`);
